/** LedAI values for Procore Tasks' selectable states, in the provider's order. */
export const PROCORE_TASK_STATUSES = [
  "initiated",
  "in_progress",
  "ready_for_review",
  "closed",
  "voided",
] as const;

/** Legacy LedAI aliases normalize to the selectable task values. */
export function normalizeProcoreTaskStatus(status: string): string {
  if (status === "not_started") return "initiated";
  if (status === "completed") return "closed";
  return status;
}

/** Procore's API calls the Void state `void`; LedAI stores it as `voided`. */
export function serializeProcoreTaskStatus(status: string): string {
  const normalized = normalizeProcoreTaskStatus(status);
  return normalized === "voided" ? "void" : normalized;
}
